import React from "react";
import GridLines from "@/components/site/GridLines";

export default function Sustainability() {
  return (
    <section className="rf-sustain" id="sustainability" data-testid="sustainability">
      <picture className="rf-sustain__media">
        <source media="(max-width: 1023px)" srcSet="/assets/m-sustain.png" />
        <img src="/assets/d-sustain.png" alt="" aria-hidden="true" />
      </picture>
      <GridLines />
      <div className="rf-sustain__body">
        <div className="rf-sustain__rule" />
        <div className="rf-wrap">
          <div className="rf-sustain__head">
            <p className="rf-label">SUSTAINABILITY</p>
            <h2 className="rf-h2">
              Process led manufacturing backed by{" "}
              <br className="rf-br-d" />
              purpose led responsibility
            </h2>
          </div>
        </div>
        <div className="rf-sustain__rule" />
        <div className="rf-wrap">
          <div className="rf-sustain__text">
            <p className="rf-cardBody">
              At Renaflex, we believe that responsible manufacturing begins with discipline.
              Renaflex focuses on manufacturing practices that support consistency, quality,
              resource efficiency and lower site wastage through modern board-based construction.
            </p>
            <p className="rf-cardBody">
              By supporting dry construction methods and versatile board usage, Renaflex helps
              reduce dependence on messy, labour-heavy and material-intensive traditional methods
              in many applications.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
